import { useState, useEffect } from 'react';
import { useTwilioAppState } from '../state/';
import { Logger } from '../utils';

export default function useIsTrackContentPreferences(track) {
    const [isContentPreferencesEnabled, setIsContentPreferencesEnabled] = useState(false);
    const { _isMounted, twilioSettings } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {
            if (track) {
                const handleTrackStarted = (track) => {
                    setIsContentPreferencesEnabled(true);
                    if (typeof track.setContentPreferences !== 'undefined' && twilioSettings && twilioSettings.settings && twilioSettings.settings.contentPreferences) {
                        try {
                            track.setContentPreferences(twilioSettings.settings.contentPreferences);
                            Logger("UI.Twilio.Room.Track.SetContentPreferences.Success", new Date(), { contentPreferences: twilioSettings.settings.contentPreferences });
                        } catch (exp) {
                            Logger("UI.Twilio.Room.Track.SetContentPreferences.Failed", new Date(), { failureRsp: exp });
                        }
                    }
                }
                track.on('started', handleTrackStarted);
                return () => {
                    track.off('started', handleTrackStarted);
                };
            }
        }
    }, [track, _isMounted]);

    return isContentPreferencesEnabled;
}
